import { Component } from "@angular/core";

@Component({
  selector: "app-icon-warning",
  standalone: true,
  imports: [],
  templateUrl: "./warning.component.html",
})
export class WarningIconComponent {}
